import { Pressable } from 'react-native';
import { Typography } from '../../../Core/Typography/Typography';
import { cn } from '../../../lib/utils';

interface CircularButtonProps {
  text: string;
  onPress?: () => void;
  isSelected?: boolean;
  className?: string;
}

export const CircularButton = ({
  text,
  onPress,
  isSelected = false,
  className,
}: CircularButtonProps) => {
  const backgroundColor = isSelected ? 'bg-primary' : 'bg-transparent';
  return (
    <Pressable
      onPress={onPress}
      className={cn(
        'h-12 w-12 items-center justify-center rounded-full',
        backgroundColor,
        className,
      )}>
      <Typography variant="callToAction">{text}</Typography>
    </Pressable>
  );
};
